<template>
  <v-layout v-if="hasClassroomSchedule" row wrap>
    <v-flex
      v-for="(item, index) in resource.form.classroom_schedules_attributes"
      :key="`classroom${index}`"
      xs6 md4>
      <h3>{{item.classroom_name}}</h3>
      <p>{{ getFormatedHour(item.hour) }}</p>
    </v-flex>
  </v-layout>

  <v-layout
    v-else
    align-center
    justify-center
    column>
    <h3>Não há registro de salas.</h3>
    <h4 class="text-secondary mb-2">There's no registration of rooms.</h4>
  </v-layout>
</template>

<script>
export default {
  name: 'FormStudentMeal',

  inject: ['resource'],

  computed: {
    hasClassroomSchedule () {
      return this.resource.form.classroom_schedules_attributes.length > 0
    }
  },

  methods: {
    getFormatedHour (hour) {
      let newHour = hour.split('T')
      return newHour[1].replace(/([0-1][0-9]|2[0-3])(:)([0-5][0-9])(.*)/, '$1$2$3')
    }
  }
}
</script>
